/** @prettier */

/**
 * i18nに翻訳データを追加する
 */

import i18n from 'i18next';

/**
 * i18nに翻訳データを追加する
 * @param fileTxt 追加する翻訳ファイルデータ(CSV形式)
 * 翻訳ファイルデータ(CSV形式)のフォーマット(仕様未定のため、仮)
 * ヘッダー行(A1)：KEY、ヘッダー行(B1)：VALUE
 * 2行目以降(An)：翻訳箇所、2行目以降(Bn)：翻訳内容
 *    A                   B
 * 1 KEY               |VALUE
 * 2 LogoSetting.title |ロゴ設定
 * 3 :                 |:
 */
export const addTranslation = (fileTxt: string) => {
  let tempCsv: string[] = [];
  let csvData: string[][] = [];

  //CSVを行ごとに分割
  //改行コードがCRLFの場合
  if (fileTxt.includes('\r\n')) {
    tempCsv = fileTxt.split('\r\n');
  }
  //改行コードがLFの場合
  else if (fileTxt.includes('\n')) {
    tempCsv = fileTxt.split('\n');
  }
  //改行コードがCRの場合
  else if (fileTxt.includes('\r')) {
    tempCsv = fileTxt.split('\r');
  }
  //CSVをセルごとに分割
  csvData = tempCsv.map(temp => {
    const [transKey, ...transValue] = temp.split(',');
    return [transKey, transValue.join(',')]; //翻訳にカンマ(,)が含まれていた場合、.join(',')で連結し元に戻す
  });
  //CSVを一行ずつ翻訳リソースに追加する
  for (const [row, rowData] of csvData.entries()) {
    //ヘッダー行は処理しない
    if (row === 0) continue;
    /** 翻訳箇所 */
    let transKey = rowData[0];
    /** 翻訳内容 */
    let transValue = rowData[1];
    //翻訳箇所が未入力の場合は処理しない
    if (transKey === '') continue;

    //翻訳に二重引用符(")が含まれる場合、不要な二重引用符を取り除く
    if (transValue.includes('"')) {
      let tempArr = transValue.split('"');
      tempArr = tempArr.filter(value => {
        return value !== '';
      });
      transValue = tempArr.join('"');
    }
    //翻訳データを追加する
    i18n.addResource('custom', 'translation', transKey, transValue);
  }
  //※仕様決定後不要となった場合に以下の記述を削除※
  // // JSONをオブジェクトデータの形式に変換
  // const jsonObj = JSON.parse(reader.result as string)
  // // 読み込んだ翻訳データを追加し、ユーザー言語に切り替える
  // for (let key in jsonObj) {
  // 	i18n.addResource('custom', 'translation', key, jsonObj[key])
  // }
};
